const flows = Object.freeze({
  CHECKIN: 'CHECKIN',
  CHECKOUT: 'CHECKOUT',
  NEW: 'NEW',
  ONBOARDING: 'ONBOARDING',
});

export default flows;
